import AnimatedLoader from 'common/animated-loader';
import React, { useState } from 'react';
import { Box } from '@spothero/ui';
const PARKING_FUN_FACTS = [
    'The average car spends 95% of its time parked.',
    'There is an estimated 2 billion parking spaces across the United States.',
    'Parking spots date back to ancient Rome, when chariots had designated parking areas.',
];
export const getRandomFactIndex = () => {
    return Math.floor(Math.random() * PARKING_FUN_FACTS.length);
};
const AirportAnimatedLoader = () => {
    const [randomFactIndex] = useState(getRandomFactIndex());
    return (<Box position="fixed" top="0" left="0" width="100%" height="100vh" backgroundColor="white" opacity="0.93" zIndex="layer10" display="flex" alignItems="center" justifyContent="center" role="status" aria-live="polite" aria-busy="true">
            <AnimatedLoader loaderText={PARKING_FUN_FACTS[randomFactIndex]}/>
        </Box>);
};
export default AirportAnimatedLoader;
